import React, { useCallback, useState } from 'react';

import Select, { SelectOption } from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { IUserJson } from '@scale/shared/types/user';

type Props = {
  placeholder?: string;
  disabled?: boolean;
  onChange: (option: SelectOption | undefined) => void;
  filterOption: (option: SelectOption) => boolean;
  value?: { value: string; label: string } | string | undefined;
  style?: React.CSSProperties;
};

type Response = {
  users: IUserJson[];
};

const SelectScalien = (props: Props) => {
  const [curTimeout, setCurTimeout] = useState<NodeJS.Timeout | null>(null);

  const fetchScalers = useCallback(
    async (email: string) => {
      if (!email) {
        return (async () => [])();
      }

      if (curTimeout) {
        clearTimeout(curTimeout);
      }

      return new Promise(resolve => {
        const newTimeout = setTimeout(async () => {
          try {
            const { users } = await apiFetch<Response>(
              null,
              `corp-api/find/scaliens?email=${encodeURIComponent(email.replace(/ /g, '.'))}`,
            );
            resolve({
              options: users.map(user => ({
                label: user.email,
                value: user.id,
              })),
            });
          } catch (error) {
            defaultApiFetchErrorHandler(error, { handleHttp: true });
          }
          return [];
        }, 500);
        setCurTimeout(newTimeout);
      });
    },
    [curTimeout],
  );

  return <Select loadOptions={fetchScalers} {...props} />;
};

export default SelectScalien;
